package team.platforma.multiplatform_material_extension.toolbar

import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarColors
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.TopAppBarScrollBehavior
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun Toolbar(
    title: @Composable () -> Unit,
    modifier: Modifier = Modifier,
    colors: TopAppBarColors = ToolbarStyle.mToolbarStyle.toToolbarColors(),
    navigationIcon: @Composable () -> Unit = {},
    actions: @Composable() (RowScope.() -> Unit) = {},
    expandedHeight: Dp = TopAppBarDefaults.TopAppBarExpandedHeight,
    windowInsets: WindowInsets = TopAppBarDefaults.windowInsets,
    scrollBehavior: TopAppBarScrollBehavior? = null
) {
    TopAppBar(
        title = title,
        modifier = modifier,
        navigationIcon = navigationIcon,
        actions = actions,
        expandedHeight = expandedHeight,
        windowInsets = windowInsets,
        colors = colors,
        scrollBehavior = scrollBehavior
    )
}

object ToolbarStyle {
    internal var mToolbarStyle = AppToolbarStyle()
    @Composable
    fun define(
        toolbarStyle: AppToolbarStyle
    ) {
        mToolbarStyle = toolbarStyle
    }

}

data class AppToolbarStyle(
    val containerColor: Color? = null,
    val scrolledContainerColor: Color? = null,
    val navigationIconContentColor: Color? = null,
    val titleContentColor: Color? = null,
    val actionIconContentColor: Color? = null
)

@Composable
@OptIn(ExperimentalMaterial3Api::class)
fun AppToolbarStyle.toToolbarColors(): TopAppBarColors = TopAppBarColors(
    containerColor = containerColor ?: MaterialTheme.colorScheme.primaryContainer,
    scrolledContainerColor = scrolledContainerColor ?: MaterialTheme.colorScheme.onPrimaryContainer,
    navigationIconContentColor = navigationIconContentColor ?: MaterialTheme.colorScheme.primary,
    titleContentColor = titleContentColor ?: MaterialTheme.colorScheme.onPrimary,
    actionIconContentColor = actionIconContentColor ?: MaterialTheme.colorScheme.onPrimary
)